export default {
  state: {
    locationInput: {
      show: false,
      isPickup: false,
      isStop: false,
      stopIndex: 0
    }
  },
  mutations: {
    showLocationInput (state) { state.locationInput.show = true },
    hideLocationInput (state) { state.locationInput.show = false },
    setIsPickup (state, value) { state.locationInput.isPickup = value },
    setIsStop (state, value) { state.locationInput.isStop = value },
    setIsStopIndex (state, value) { state.locationInput.stopIndex = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/location-input.js